<div class="glxy-button-group-body">
  <ng-content />
</div>
